var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('el-form-item',{attrs:{"label":_vm.label}},[_c('el-image',{staticClass:"style-img",attrs:{"src":_vm.imgUrl,"preview-src-list":_vm.srcList}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }